import React from 'react';

import Grid from "@material-ui/core/Grid";
import BeagleHistoryCard from "./BeagleHistoryCard";


export default function BeagleHistoryContainer(props) {


    if (props.beagleCalculatorHistory.history === undefined) {
        return '';
    }

    let tableKey = 0;

    return (
        props.beagleCalculatorHistory.history.map((h) => (
                <Grid item xs={12} md={6} lg={4} key={tableKey++}>
                    <BeagleHistoryCard
                        beagleLanguagePreference={props.beagleLanguagePreference}
                        beagleCropCalculation={h}
                        removeBeagleCalculatorHistory={props.removeBeagleCalculatorHistory}
                        hideClearButton={false}
                    />
                </Grid>
            )
        )

    );

}
